import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/common/App";
import "./global.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
